import { faSync } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AccountItem, AccountItemLine } from "./AccountItem";
import { UpgradePlanButton } from "./UpgradePlanButton";
import { getTimeLeftInFreeTrial } from "./utils";
import { useCurrentUser } from "../../hooks";
import AccountStatus from "../layout/header/AccountStatus";

export default function FreePlanSettings({ user }) {
  const { data: userData } = useCurrentUser();
  const accountType = userData?.user?.account?.accountType;
  const freeTrialExpiresAt =
    userData?.user?.account?.freeTrialExpiresAt;
  const timeLeft = getTimeLeftInFreeTrial(freeTrialExpiresAt);

  return (
    <AccountItem
      title="Subscription Details"
      icon={<FontAwesomeIcon icon={faSync} size="lg" color="gray" />}
    >
      <div className="flex items-center justify-between w-full">
        <div className="flex-1 divide-y dark:divide-gray-700">
          <AccountItemLine title="Plan Type:">
            {accountType === "basic" && !timeLeft.isExpired
              ? `You are currently on a Free Trial with ${timeLeft.formattedTime}.`
              : "You are currently on the Free Plan."}
          </AccountItemLine>
          <AccountItemLine title="Feature Access:">
            <div className="flex flex-col md:flex-row items-center text-center md:text-left md:space-x-2 space-y-2 md:space-y-0">
              <AccountStatus small />

              <span className="text-xs md:text-sm">
                {accountType === "basic" && !timeLeft.isExpired
                  ? "Upgrade your account to keep using all features after your trial ends."
                  : "Upgrade your account to access all Scribenote features."}
              </span>
            </div>
          </AccountItemLine>
        </div>

        {user?.email?.includes("@mvetpartners.com") ||
        user?.email?.includes("@svp.vet") ? null : (
          <div id="accountSubscriptionOptions" className="ml-6">
            <UpgradePlanButton featureName="Free Plan Settings" />
          </div>
        )}
      </div>
    </AccountItem>
  );
}
